import React from "react";

const MobileWidgets = () => {
  return (
    <div className="offcanvas-widget-area">
      <div className="off-canvas-contact-widget">
        <div className="header-contact-info">
          <ul className="header-contact-info__list">
            <li>
              <i className="fa fa-phone"></i>{" "}
              <a href='callto:85226042833'>(852) 2604 2833</a>
            </li>
            <li>
              <i className="fa fa-envelope"></i>{" "}
              <a href='mailto:info@whmsl.com.hk'>info@whmsl.com.hk</a>
            </li>
            <li>
              <i className="fa fa-whatsapp"></i>{" "}
              <a href='https://api.whatsapp.com/send?phone=85291466835'>(852) 9146 6835</a>
            </li>            
          </ul>
        </div>
      </div>
      {/*Off Canvas Widget Social Start*/}
      <div className="off-canvas-widget-social">        
        <a href="https://www.instagram.com/winghangmedicalsupplies" 
            target="_blank"
            rel="noopener noreferrer"           
           title="Instagram">
          <i className="fa fa-instagram"></i>
        </a>
        <a
            href="https://www.facebook.com/winghangmedical"
            target="_blank"
            rel="noopener noreferrer"
            title="Facebook">
          <i className="fa fa-facebook"></i>
        </a>

      </div>
      {/*Off Canvas Widget Social End*/}
    </div>
  );
};

export default MobileWidgets;
